/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../privacyvault/annotations';
import '../bank-accounts/bank_accounts';
import '../bills/client_details';
import '../common/time';
import '../common/location';
import '../common/protocols';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "simple_instrument_store": {
        "nested": {
          "LinkAttemptStatus": {
            "values": {
              "INVALID_STATUS": 0,
              "SUCCESS": 1,
              "CARD_NUMBER_INVALID": 2,
              "CARD_NUMBER_UNSUPPORTED": 3,
              "EXPIRATION_INVALID": 4,
              "EXPIRED": 5,
              "SECURITY_CODE_INVALID": 6,
              "POSTAL_CODE_INVALID": 7,
              "POSTAL_CODE_UNSUPPORTED": 8,
              "VERIFICATION_ERROR": 9,
              "TOO_MANY_ATTEMPTS": 10,
              "TOO_MANY_LINKS": 11,
              "HAS_GRINGOTTS_BLOCKER": 12,
              "UNVERIFIED": 13,
              "LINKING_NOT_SUPPORTED": 14,
              "CARD_DECLINED_VERIFICATION_REQUIRED": 15
            }
          },
          "Brand": {
            "values": {
              "INVALID": 0,
              "UNKNOWN": 1,
              "VISA": 2,
              "MASTERCARD": 3,
              "AMEX": 4,
              "DISCOVER": 5,
              "DISCOVER_DINERS": 6,
              "JCB": 7,
              "UNION_PAY": 8,
              "SQUARE_GIFT_CARD_V2": 9,
              "INTERAC": 10,
              "SQUARE_CAPITAL_CARD": 11,
              "EFTPOS": 12,
              "FELICA": 13,
              "ALIPAY": 14,
              "CASH_APP": 15,
              "EBT": 16,
              "PAYPAY": 17,
              "AFTERPAY": 18,
              "SQUARE_ACCOUNT_BALANCE": 19,
              "AU_PAY": 20,
              "WECHAT_PAY": 21,
              "D_BARAI": 22,
              "MERPAY": 23,
              "RAKUTEN_PAY": 24,
              "STORED_VALUE": 25,
              "QUICPAY": 26,
              "ID": 27,
              "TRANSPORTATION_IC": 28,
              "CASH_LOCAL": 29,
              "LOCAL_CASH": 30
            }
          },
          "CardLinkingEntryMethod": {
            "values": {
              "UNKNOWN_ENTRY_METHOD": 0,
              "SWIPED": 1,
              "KEYED": 2,
              "EMV": 3,
              "CONTACTLESS": 4,
              "PAYMENT_TOKEN": 5
            }
          },
          "Card": {
            "fields": {
              "panFideliusToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "bin": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "lastFour": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "cardholderName": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "postalCode": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "expirationDate": {
                "type": ".squareup.simple_instrument_store.ExpirationDate",
                "id": 7,
                "rule": "optional"
              },
              "brand": {
                "type": ".squareup.simple_instrument_store.Brand",
                "id": 8,
                "rule": "optional"
              },
              "secureCardData": {
                "type": ".squareup.simple_instrument_store.SecureCardData",
                "id": 9,
                "rule": "optional"
              },
              "encryptedSecureCardData": {
                "type": ".squareup.simple_instrument_store.EncryptedSecureCardData",
                "id": 10,
                "rule": "optional"
              },
              "entryMethod": {
                "type": ".squareup.simple_instrument_store.CardLinkingEntryMethod",
                "id": 11,
                "rule": "optional"
              },
              "verificationPaymentToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "verificationPaymentData": {
                "type": "bytes",
                "id": 13,
                "rule": "optional"
              }
            }
          },
          "SecureCardData": {
            "fields": {
              "securityCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "vaultedData": {
                "type": ".squareup.privacyvault.VaultedData",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "EncryptedSecureCardData": {
            "fields": {
              "encryptionKeyToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "encryptedData": {
                "type": "bytes",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "Bank": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "bankAccount": {
                "type": ".squareup.bank_accounts.BankAccount",
                "id": 2,
                "rule": "optional"
              },
              "squareWebVerificationState": {
                "type": ".squareup.simple_instrument_store.Bank.SquareWebBankAccountState",
                "id": 3,
                "rule": "optional"
              },
              "productTags": {
                "type": ".squareup.simple_instrument_store.ProductTag",
                "id": 4,
                "rule": "repeated"
              }
            },
            "nested": {
              "SquareWebBankAccountState": {
                "values": {
                  "DO_NOT_USE": 0,
                  "CREATED": 1,
                  "AWAITING_USER_APPROVAL": 2,
                  "RECEIVED_USER_APPROVAL": 3,
                  "AWAITING_DEBIT_AUTHORIZATION": 4,
                  "DEPOSITS_SENT": 5,
                  "UNVERIFIED_WITH_DEPOSITS_SENT": 6,
                  "DEPOSITS_PENDING": 7,
                  "UNVERIFIED_WITH_DEPOSITS_PENDING": 8,
                  "VERIFIED_WITH_DEPOSITS_PENDING": 9,
                  "VERIFIED": 10,
                  "VERIFIED_CREDIT_ONLY": 11,
                  "VERIFICATION_CANCELED": 12,
                  "FAILED": 13
                }
              }
            }
          },
          "ExpirationDate": {
            "fields": {
              "year": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              },
              "month": {
                "type": "uint32",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "Product": {
            "values": {
              "NONE": 0,
              "APPOINTMENTS": 5,
              "CARD": 1,
              "CASH": 2,
              "MERCHANT_BILLING": 3,
              "RECEIPTS": 4,
              "MERCHANT_SETTLEMENT": 6,
              "INSTRUMENT_ON_FILE": 7,
              "WHITE_LABEL": 8,
              "PAYROLL": 9,
              "LOYALTY": 10,
              "CAPITAL": 11,
              "ONLINE_STORE": 12,
              "STORE": 13,
              "LUNCH_REIMBURSER": 14,
              "INSTANT_DEPOSIT": 15,
              "EGIFTING": 16,
              "CONNECT_V2_API": 17
            }
          },
          "ProductTag": {
            "values": {
              "PRODUCT_TAG_UNSPECIFIED": 0,
              "INSTANT_TRANSFER_INELIGIBLE": 1
            }
          },
          "Entity": {
            "fields": {
              "tokenType": {
                "type": ".squareup.simple_instrument_store.Entity.TokenType",
                "id": 1,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "TokenType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "APPOINTMENT": 1,
                  "PERSON": 2,
                  "WEB_MERCHANT": 3,
                  "MERCHANT_CONTACT": 4,
                  "LOYALTY_CONTACT": 5,
                  "CAPITAL_CUSTOMER": 6,
                  "ANONYMOUS": 7,
                  "UNIT": 8,
                  "PLATFORM_ACCOUNT": 9,
                  "OAUTH_APPLICATION": 10
                }
              }
            }
          },
          "OwnershipContext": {
            "fields": {
              "owningEntity": {
                "type": ".squareup.simple_instrument_store.Entity",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ProductContext": {
            "fields": {
              "product": {
                "type": ".squareup.simple_instrument_store.Product",
                "id": 1,
                "rule": "optional"
              },
              "subProduct": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "UsageContext": {
            "fields": {
              "productContext": {
                "type": ".squareup.simple_instrument_store.ProductContext",
                "id": 1,
                "rule": "repeated"
              },
              "ownershipContext": {
                "type": ".squareup.simple_instrument_store.OwnershipContext",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "LinkContext": {
            "fields": {
              "linkingEntity": {
                "type": ".squareup.simple_instrument_store.Entity",
                "id": 1,
                "rule": "optional"
              },
              "browserInteraction": {
                "type": ".squareup.simple_instrument_store.BrowserInteraction",
                "id": 2,
                "rule": "optional"
              },
              "linkingSource": {
                "type": ".squareup.simple_instrument_store.LinkContext.LinkingSource",
                "id": 3,
                "rule": "optional"
              },
              "clientDetails": {
                "type": ".squareup.bills.ClientDetails",
                "id": 4,
                "rule": "optional"
              },
              "linkingPaymentToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "initiatingEntity": {
                "type": ".squareup.simple_instrument_store.Entity",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "LinkingSource": {
                "values": {
                  "UNKNOWN": 0,
                  "WEB": 1,
                  "XP_API": 2,
                  "REGISTER_CLIENT": 3,
                  "PANFRESH": 4,
                  "CAPITAL": 5,
                  "LEDGER": 6,
                  "INVOICES": 7,
                  "CUSTOMER_DIRECTORY": 8,
                  "GIFTCARD": 9,
                  "VIRTUAL_TERMINAL": 10,
                  "READER_SDK": 11,
                  "BUYER_DASHBOARD": 12,
                  "SQUARE_PROFILE": 13,
                  "SQUARE_LOCAL": 14
                }
              }
            }
          },
          "UnlinkContext": {
            "fields": {
              "entity": {
                "type": ".squareup.simple_instrument_store.Entity",
                "id": 1,
                "rule": "optional"
              },
              "unlinkingSource": {
                "type": ".squareup.simple_instrument_store.UnlinkContext.UnlinkingSource",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "UnlinkingSource": {
                "values": {
                  "UNKNOWN": 0,
                  "AUTOMATIC": 1,
                  "DASHBOARD": 2,
                  "XP_API": 3,
                  "REGISTER_CLIENT": 4,
                  "BUYER_DASHBOARD": 5
                }
              }
            }
          },
          "AuthenticationContext": {
            "fields": {
              "confirmationCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "confirmationCodeExpiresAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 2,
                "rule": "optional"
              },
              "authenticationRequired": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "authenticationState": {
                "type": ".squareup.simple_instrument_store.AuthenticationContext.AuthenticationState",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "AuthenticationState": {
                "values": {
                  "UNKNOWN": 0,
                  "PENDING": 1,
                  "EXPIRED": 2,
                  "AUTHENTICATED": 3
                }
              }
            }
          },
          "FailContext": {
            "fields": {
              "failedAt": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "failureReason": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "Instrument": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "linkingInfo": {
                "type": ".squareup.simple_instrument_store.LinkingInfo",
                "id": 2,
                "rule": "optional"
              },
              "usageContext": {
                "type": ".squareup.simple_instrument_store.UsageContext",
                "id": 15,
                "rule": "optional"
              },
              "linkContext": {
                "type": ".squareup.simple_instrument_store.LinkContext",
                "id": 16,
                "rule": "optional"
              },
              "unlinkContext": {
                "type": ".squareup.simple_instrument_store.UnlinkContext",
                "id": 20,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.simple_instrument_store.Instrument.Type",
                "id": 12,
                "rule": "optional"
              },
              "active": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "linkedAt": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              },
              "verifiedAt": {
                "type": "int64",
                "id": 14,
                "rule": "optional"
              },
              "unlinkedAt": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "frozenAt": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "nickname": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "metadata": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "ordinal": {
                "type": "int32",
                "id": 10,
                "rule": "optional"
              },
              "billingAddress": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 17,
                "rule": "optional"
              },
              "duplicateLinkAttempt": {
                "type": ".squareup.simple_instrument_store.DuplicateLinkAttempt",
                "id": 11,
                "rule": "repeated"
              },
              "isSingleUse": {
                "type": "bool",
                "id": 18,
                "rule": "optional"
              },
              "sessionToken": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "authenticationContext": {
                "type": ".squareup.simple_instrument_store.AuthenticationContext",
                "id": 22,
                "rule": "optional"
              },
              "vaultedData": {
                "type": ".squareup.privacyvault.VaultedData",
                "id": 23,
                "rule": "optional"
              },
              "referenceId": {
                "type": "string",
                "id": 26,
                "rule": "optional"
              },
              "linkingOauthApplication": {
                "type": "string",
                "id": 28,
                "rule": "optional"
              },
              "failContext": {
                "type": ".squareup.simple_instrument_store.FailContext",
                "id": 29,
                "rule": "optional"
              },
              "card": {
                "type": ".squareup.simple_instrument_store.Card",
                "id": 3
              },
              "bank": {
                "type": ".squareup.simple_instrument_store.Bank",
                "id": 13
              },
              "owningTokenPair": {
                "type": ".squareup.simple_instrument_store.OwningTokenPair",
                "id": 19
              },
              "paymentIdempotencyKey": {
                "type": "string",
                "id": 25
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "CARD": 1,
                  "BANK": 2
                }
              },
              "instrument_data": {
                "oneof": ["card", "bank"]
              },
              "locking_key": {
                "oneof": ["owningTokenPair", "paymentIdempotencyKey"]
              }
            }
          },
          "OwningTokenPair": {
            "fields": {
              "billClientToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "tenderClientToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "LinkingInfo": {
            "fields": {
              "product": {
                "type": ".squareup.simple_instrument_store.Product",
                "id": 1,
                "rule": "optional"
              },
              "accountTokenType": {
                "type": ".squareup.simple_instrument_store.LinkingInfo.AccountTokenType",
                "id": 6,
                "rule": "optional"
              },
              "accountToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "linkingUserToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "linkingUserTokenType": {
                "type": ".squareup.simple_instrument_store.LinkingInfo.AccountTokenType",
                "id": 9,
                "rule": "optional"
              },
              "accountOwnerMerchantToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "verificationPending": {
                "type": "bool",
                "id": 8,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "attemptStatus": {
                "type": ".squareup.simple_instrument_store.LinkAttemptStatus",
                "id": 5,
                "rule": "optional"
              },
              "browserInteraction": {
                "type": ".squareup.simple_instrument_store.BrowserInteraction",
                "id": 7,
                "rule": "optional"
              },
              "linkingSource": {
                "type": ".squareup.simple_instrument_store.LinkContext.LinkingSource",
                "id": 11,
                "rule": "optional"
              },
              "clientDetails": {
                "type": ".squareup.bills.ClientDetails",
                "id": 12,
                "rule": "optional"
              }
            },
            "nested": {
              "AccountTokenType": {
                "values": {
                  "APPOINTMENT": 1,
                  "CUSTOMER": 2,
                  "MERCHANT": 3,
                  "MERCHANT_CONTACT": 4,
                  "LOYALTY_CONTACT": 5,
                  "CAPITAL_CUSTOMER": 6,
                  "ANONYMOUS": 7,
                  "UNIT": 8,
                  "PLATFORM_ACCOUNT": 9,
                  "OAUTH_APPLICATION": 10
                }
              }
            }
          },
          "BrowserInteraction": {
            "fields": {
              "timestamp": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "antibotReport": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "clientIp": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "trackingCookie": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "requestHeaders": {
                "type": ".squareup.common.Headers",
                "id": 5,
                "rule": "optional"
              },
              "siftScienceDeviceId": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "DuplicateLinkAttempt": {
            "fields": {
              "linkingInfo": {
                "type": ".squareup.simple_instrument_store.LinkingInfo",
                "id": 1,
                "rule": "optional"
              },
              "card": {
                "type": ".squareup.simple_instrument_store.Card",
                "id": 2,
                "rule": "optional"
              },
              "bank": {
                "type": ".squareup.simple_instrument_store.Bank",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.LinkAttemptStatus && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Brand && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.CardLinkingEntryMethod && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Card && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.SecureCardData && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.EncryptedSecureCardData && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Bank && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Bank?.nested?.SquareWebBankAccountState && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.ExpirationDate && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Product && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.ProductTag && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Entity && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Entity?.nested?.TokenType && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.OwnershipContext && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.ProductContext && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.UsageContext && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.LinkContext && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.LinkContext?.nested?.LinkingSource && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.UnlinkContext && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.UnlinkContext?.nested?.UnlinkingSource && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.AuthenticationContext && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.AuthenticationContext?.nested?.AuthenticationState && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.FailContext && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Instrument && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.Instrument?.nested?.Type && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.OwningTokenPair && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.LinkingInfo && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.LinkingInfo?.nested?.AccountTokenType && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.BrowserInteraction && !$root.nested?.squareup?.nested?.simple_instrument_store?.nested?.DuplicateLinkAttempt) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LinkAttemptStatus @ squareup/simple_instrument_store/model.proto at 17:1
 */
export const LinkAttemptStatus = $root.lookupEnum('squareup.simple_instrument_store.LinkAttemptStatus').values;
/**
 * This is explicitly different from squareup.common.instrument.InstrumentType. The latter
 * represents instrument types the payment stack can charge or process in different ways.
 * e.g. Balance (giftcards) is mixed in that enum.
 *
 * SOURCE Brand @ squareup/simple_instrument_store/model.proto at 115:1
 */
export const Brand = $root.lookupEnum('squareup.simple_instrument_store.Brand').values;
/**
 * SOURCE CardLinkingEntryMethod @ squareup/simple_instrument_store/model.proto at 150:1
 */
export const CardLinkingEntryMethod = $root.lookupEnum('squareup.simple_instrument_store.CardLinkingEntryMethod').values;
/**
 * SOURCE Card @ squareup/simple_instrument_store/model.proto at 159:1
 */
export const Card = $root.lookupType('squareup.simple_instrument_store.Card');
fixType(Card, {
  panFideliusToken: {
    notEmpty: true
  },
  bin: {
    required: true
  },
  lastFour: {
    required: true
  }
});
Builder.createAndAttachToType(Card);
/**
 * SOURCE SecureCardData @ squareup/simple_instrument_store/model.proto at 261:1
 */
export const SecureCardData = $root.lookupType('squareup.simple_instrument_store.SecureCardData');
fixType(SecureCardData);
Builder.createAndAttachToType(SecureCardData);
/**
 * SOURCE EncryptedSecureCardData @ squareup/simple_instrument_store/model.proto at 273:1
 */
export const EncryptedSecureCardData = $root.lookupType('squareup.simple_instrument_store.EncryptedSecureCardData');
fixType(EncryptedSecureCardData, {
  encryptionKeyToken: {
    required: true
  },
  encryptedData: {
    required: true
  }
});
Builder.createAndAttachToType(EncryptedSecureCardData);
/**
 * A bank instrument, comprised of a Gringotts token and basic bank account information.
 *
 * SOURCE Bank @ squareup/simple_instrument_store/model.proto at 280:1
 */
export const Bank = $root.lookupType('squareup.simple_instrument_store.Bank');
fixType(Bank, {
  token: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Bank);
/**
 * Square Web specific bank account states copied from VerificationState.java
 *
 * SOURCE SquareWebBankAccountState @ squareup/simple_instrument_store/model.proto at 304:3
 */
Bank.SquareWebBankAccountState = $root.lookupEnum('squareup.simple_instrument_store.Bank.SquareWebBankAccountState').values;
/**
 * SOURCE ExpirationDate @ squareup/simple_instrument_store/model.proto at 331:1
 */
export const ExpirationDate = $root.lookupType('squareup.simple_instrument_store.ExpirationDate');
fixType(ExpirationDate, {
  year: {
    required: true
  },
  month: {
    required: true
  }
});
Builder.createAndAttachToType(ExpirationDate);
/**
 * The scope of the linked instrument.
 *
 * Next enum val = 16;
 *
 * SOURCE Product @ squareup/simple_instrument_store/model.proto at 352:1
 */
export const Product = $root.lookupEnum('squareup.simple_instrument_store.Product').values;
/**
 * SOURCE ProductTag @ squareup/simple_instrument_store/model.proto at 474:1
 */
export const ProductTag = $root.lookupEnum('squareup.simple_instrument_store.ProductTag').values;
/**
 * SOURCE Entity @ squareup/simple_instrument_store/model.proto at 479:1
 */
export const Entity = $root.lookupType('squareup.simple_instrument_store.Entity');
fixType(Entity, {
  tokenType: {
    required: true
  },
  token: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Entity);
/**
 * SOURCE TokenType @ squareup/simple_instrument_store/model.proto at 480:3
 */
Entity.TokenType = $root.lookupEnum('squareup.simple_instrument_store.Entity.TokenType').values;
/**
 * SOURCE OwnershipContext @ squareup/simple_instrument_store/model.proto at 532:1
 */
export const OwnershipContext = $root.lookupType('squareup.simple_instrument_store.OwnershipContext');
fixType(OwnershipContext, {
  owningEntity: {
    required: true
  }
});
Builder.createAndAttachToType(OwnershipContext);
/**
 * Context to store product associations.
 *
 * SOURCE ProductContext @ squareup/simple_instrument_store/model.proto at 544:1
 */
export const ProductContext = $root.lookupType('squareup.simple_instrument_store.ProductContext');
fixType(ProductContext, {
  product: {
    required: true
  }
});
Builder.createAndAttachToType(ProductContext);
/**
 * Context which defines how this instrument is supposed to be used.
 *
 * SOURCE UsageContext @ squareup/simple_instrument_store/model.proto at 559:1
 */
export const UsageContext = $root.lookupType('squareup.simple_instrument_store.UsageContext');
fixType(UsageContext, {
  ownershipContext: {
    required: true
  }
});
Builder.createAndAttachToType(UsageContext);
/**
 * Context to store the linking time information.
 *
 * SOURCE LinkContext @ squareup/simple_instrument_store/model.proto at 571:1
 */
export const LinkContext = $root.lookupType('squareup.simple_instrument_store.LinkContext');
fixType(LinkContext);
Builder.createAndAttachToType(LinkContext);
/**
 * SOURCE LinkingSource @ squareup/simple_instrument_store/model.proto at 581:3
 */
LinkContext.LinkingSource = $root.lookupEnum('squareup.simple_instrument_store.LinkContext.LinkingSource').values;
/**
 * Context to store unlinking information.
 *
 * SOURCE UnlinkContext @ squareup/simple_instrument_store/model.proto at 631:1
 */
export const UnlinkContext = $root.lookupType('squareup.simple_instrument_store.UnlinkContext');
fixType(UnlinkContext);
Builder.createAndAttachToType(UnlinkContext);
/**
 * SOURCE UnlinkingSource @ squareup/simple_instrument_store/model.proto at 638:3
 */
UnlinkContext.UnlinkingSource = $root.lookupEnum('squareup.simple_instrument_store.UnlinkContext.UnlinkingSource').values;
/**
 * Context to store authentication information during linking.
 *
 * SOURCE AuthenticationContext @ squareup/simple_instrument_store/model.proto at 675:1
 */
export const AuthenticationContext = $root.lookupType('squareup.simple_instrument_store.AuthenticationContext');
fixType(AuthenticationContext);
Builder.createAndAttachToType(AuthenticationContext);
/**
 * SOURCE AuthenticationState @ squareup/simple_instrument_store/model.proto at 686:3
 */
AuthenticationContext.AuthenticationState = $root.lookupEnum('squareup.simple_instrument_store.AuthenticationContext.AuthenticationState').values;
/**
 * Context to store the information when the instrument gets failed
 *
 * SOURCE FailContext @ squareup/simple_instrument_store/model.proto at 705:1
 */
export const FailContext = $root.lookupType('squareup.simple_instrument_store.FailContext');
fixType(FailContext, {
  failedAt: {
    required: true
  }
});
Builder.createAndAttachToType(FailContext);
/**
 * A payment instrument linked by a Square customer for use with a product.
 *
 * This message models both successful links (e.g. for cards that can be used for money movement)
 * and unsuccessful links (which inform risk via regulator).
 *
 * Each instrument is associated with a single product. The store may have multiple
 * links for the same instrument (PAN, exp, etc.). Repeated instruments occurs when multiple
 * products use the same card or when multiple Square customers use the same instrument.
 *
 * A new instrument is always created for every link attempt. To check if an instrument already
 * exists, use QueryInstrument.
 *
 * Instrument can be used for new transactions if it was successfully linked and
 * is not yet unlinked.
 *
 * The current state of the instrument (* denotes valid start states):
 *
 *  chargeable          not chargeable
 *  ----------          ---------------
 *
 *                      FAILED_LINK_ATTEMPTED*
 *
 *  ACTIVE* ----------> UNLINKED ---> UNLINKED & FROZEN
 *                |
 *                |
 *                |---> FROZEN ----> FROZEN & UNLINKED
 *
 * SOURCE Instrument @ squareup/simple_instrument_store/model.proto at 746:1
 */
export const Instrument = $root.lookupType('squareup.simple_instrument_store.Instrument');
fixType(Instrument, {
  token: {
    notEmpty: true
  },
  usageContext: {
    required: true
  },
  active: {
    required: true
  }
});
Builder.createAndAttachToType(Instrument);
/**
 * SOURCE Type @ squareup/simple_instrument_store/model.proto at 770:3
 */
Instrument.Type = $root.lookupEnum('squareup.simple_instrument_store.Instrument.Type').values;
/**
 * The combination of bill client token and tender client token a single use instrument has been
 * pinned to.
 *
 * SOURCE OwningTokenPair @ squareup/simple_instrument_store/model.proto at 915:1
 */
export const OwningTokenPair = $root.lookupType('squareup.simple_instrument_store.OwningTokenPair');
fixType(OwningTokenPair, {
  billClientToken: {
    notEmpty: true
  },
  tenderClientToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OwningTokenPair);
/**
 * SOURCE LinkingInfo @ squareup/simple_instrument_store/model.proto at 921:1
 */
export const LinkingInfo = $root.lookupType('squareup.simple_instrument_store.LinkingInfo');
fixType(LinkingInfo, {
  product: {
    required: true
  },
  accountToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LinkingInfo);
/**
 * SOURCE AccountTokenType @ squareup/simple_instrument_store/model.proto at 926:3
 */
LinkingInfo.AccountTokenType = $root.lookupEnum('squareup.simple_instrument_store.LinkingInfo.AccountTokenType').values;
/**
 * BrowserInteraction information is gathered from the user in the browser
 *
 * SOURCE BrowserInteraction @ squareup/simple_instrument_store/model.proto at 1026:1
 */
export const BrowserInteraction = $root.lookupType('squareup.simple_instrument_store.BrowserInteraction');
fixType(BrowserInteraction);
Builder.createAndAttachToType(BrowserInteraction);
/**
 * (Deprecated) Used when a link attempt collides with an existing active instrument.
 *
 * SOURCE DuplicateLinkAttempt @ squareup/simple_instrument_store/model.proto at 1085:1
 */
export const DuplicateLinkAttempt = $root.lookupType('squareup.simple_instrument_store.DuplicateLinkAttempt');
fixType(DuplicateLinkAttempt);
Builder.createAndAttachToType(DuplicateLinkAttempt);